import script from "./TempC.vue?vue&type=script&lang=ts&setup=true"
export * from "./TempC.vue?vue&type=script&lang=ts&setup=true"

import "./TempC.vue?vue&type=style&index=0&id=69bf5c2b&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69bf5c2b"]])

export default __exports__